import { FC } from 'react'

import styled from 'styled-components'

import { capitalizeFirstLetter } from 'src/Helpers/layoutHelpers'
import { SpotifyArtist } from 'src/Redux/spotifyArtistsApi'
import { LabelForArtist } from 'src/Components/LabelForArtist'

type Props = {
  artists?: SpotifyArtist[]
  onClickArtist: (artist: SpotifyArtist) => void
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`
const Title = styled.h3`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  width: 100%;
  margin: 0;
`
const List = styled.ul`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px;
`

export const AdSelectedArtistsList: FC<Props> = ({
  artists,
  onClickArtist,
}) => {
  if (!artists || artists.length === 0) {
    return null
  }
  return (
    <Container>
      <Title>Selected ({artists.length})</Title>
      <List>
        {artists.map((artist) => (
          <LabelForArtist
            key={artist.photoUrl}
            title={capitalizeFirstLetter(artist.name)}
            selected
            onClick={() => onClickArtist(artist)}
            imgUrl={artist.photoUrl}
          />
        ))}
      </List>
    </Container>
  )
}
